import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  SET_PAGE,
  SET_PAGE_SIZE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  MARK_MUTATION_IDLE,
} from '../actions/UserActions';
import { MutationStatuses } from './constants';

const initialState = {
  loading: false,
  users: [],
  totalUsers: 0,
  page: 1,
  pageSize: 10,
  error: null,
  mutationStatus: MutationStatuses.IDLE,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
      return { ...state, loading: true };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload.users,
        totalUsers: action.payload.totalUsers,
      };
    case FETCH_USERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_PAGE:
      return { ...state, page: action.payload };
    case SET_PAGE_SIZE:
      return { ...state, pageSize: action.payload, page: 1 };
    case DELETE_USER_REQUEST:
      return { ...state, mutationStatus: MutationStatuses.IN_PROGRESS };
    case DELETE_USER_SUCCESS:
      return { ...state, mutationStatus: MutationStatuses.SUCCESS };
    case DELETE_USER_FAILURE:
      return {
        ...state,
        mutationStatus: MutationStatuses.FAILURE,
        error: action.payload,
      };
    case MARK_MUTATION_IDLE:
      return {
        ...state,
        mutationStatus: MutationStatuses.IDLE,
      };
    default:
      return state;
  }
};

export default userReducer;
